import Header from "@/components/header";
import { DiscountSearchBox } from "@/modules/discount/searchBox/discountSearchBox";
import { Alert, Button, Group, Image, Stack, Text } from "@mantine/core";
import HotDealLogo from "../../../assets/images/hot-deal.png";
import { useNavigate } from "react-router-dom";

export function Discount() {
  const navigate = useNavigate();
  return (
    <Stack mih="100svh">
      <Header showHome showBack title="تخفیفات" />
      <Stack flex={1} px="md">
        <Alert>
          <Stack onClick={() => navigate("/dashboard/discount/selectGroup")}>
            <Group justify="space-between" wrap="nowrap">
              <Text size="sm" ta="justify">
                پیامک تخفیفی منتظر شماست! پیامک تخفیفی تبلیغاتی خود را با چند
                کلیک بسازید و فروشتان را افزایش دهید.
              </Text>
              <Image src={HotDealLogo} w={50} />
            </Group>
            <Button variant="outline">+ ایجاد کد تخفیف</Button>
          </Stack>
        </Alert>
        <DiscountSearchBox />
      </Stack>
    </Stack>
  );
}
